import { useState } from "react";
import { api, ApiClientError } from "../../lib/apiClient.js";
import { Button } from "../ui/button.js";
import { Modal } from "../ui/modal.js";
import { SelectInput, TextInput } from "../ui/field.js";
import { useToast } from "../../lib/useToast.js";
import { useI18n } from "../../i18n/index.js";

export function LocationDialog({
  open,
  onOpenChange,
  onCreated,
}: {
  open: boolean;
  onOpenChange(open: boolean): void;
  onCreated(): void;
}) {
  const { push } = useToast();
  const { t } = useI18n();
  const [form, setForm] = useState({ code: "", name: "", kind: "store" });

  const submit = async () => {
    try {
      await api.createStockLocation(form);
      push(t("inventory.locationAdded"), form.name);
      setForm({ code: "", name: "", kind: "store" });
      onOpenChange(false);
      onCreated();
    } catch (err) {
      if (err instanceof ApiClientError) push(err.message, undefined, "danger");
    }
  };

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title={t("inventory.addLocationTitle")}
      footer={
        <>
          <Button variant="secondary" onClick={() => onOpenChange(false)}>
            {t("common.cancel")}
          </Button>
          <Button
            variant="primary"
            onClick={submit}
            disabled={!form.code.trim() || !form.name.trim()}
          >
            {t("inventory.saveLocation")}
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-3">
        <TextInput
          label={t("common.fields.code")}
          value={form.code}
          onChange={(e) => setForm((f) => ({ ...f, code: e.target.value }))}
        />
        <TextInput
          label={t("common.fields.name")}
          value={form.name}
          onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
        />
        <SelectInput
          label={t("common.fields.kind")}
          options={[
            { value: "store", label: t("inventory.locationKind.store") },
            { value: "floor", label: t("inventory.locationKind.floor") },
            { value: "quarantine", label: t("inventory.locationKind.quarantine") },
            { value: "other", label: t("inventory.locationKind.other") },
          ]}
          value={form.kind}
          onChange={(e) => setForm((f) => ({ ...f, kind: e.target.value }))}
        />
      </div>
    </Modal>
  );
}
